import { render, staticRenderFns } from "./bridgeDetails.vue?vue&type=template&id=6062ab8a&scoped=true&"
import script from "./bridgeDetails.vue?vue&type=script&lang=js&"
export * from "./bridgeDetails.vue?vue&type=script&lang=js&"
import style0 from "./bridgeDetails.vue?vue&type=style&index=0&id=6062ab8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062ab8a",
  null
  
)

export default component.exports